//css-------------------
import "@/css/home/sponsor.scss";
import "@/css/share/_reset.scss";
import "@/css/share/_base.scss";
import "@/css/share/_share.scss";
import "@/css/share/components/_lightbox.scss";
import "@/css/share/components/_loading.scss";
import "@/css/share/components/_header.scss";
import "@/css/share/components/_footer.scss";
import "@/css/share/components/_footer_sponsor.scss";
import "@/css/share/components/_fastlink.scss";
import "@/css/share/components/_input.scss";
import "@/css/share/components/_maintitle.scss";
import "@/css/share/components/_breadcrumbs.scss";
import "@/css/share/components/_top_cate.scss";
import "@/css/share/components/_tpl.scss";
import "@/css/share/components/_backbtn.scss";
import "@/css/share/components/_content.scss";
import "@/css/share/components/_sec_title.scss";
import "@/css/share/components/_tab_row.scss";
import "@/css/share/components/_icon_arrow.scss";


//swiper
import(/* webpackPrefetch: true */ "swiper/css");

//fontawesome
import(/* webpackPrefetch: true */ "@/lib/fontawesome/css/fontawesome.min.css");
import(/* webpackPrefetch: true */ "@/lib/fontawesome/css/brands.min.css");
import(/* webpackPrefetch: true */ "@/lib/fontawesome/css/solid.min.css");
import(/* webpackPrefetch: true */ "@/lib/fontawesome/css/regular.min.css");
import(/* webpackPrefetch: true */ "@/lib/fontawesome/css/light.min.css");


//components js-------------------
import(/* webpackPrefetch: true */ "@/js/share/components/_common_lazy");
import(/* webpackPrefetch: true */ "@/js/share/components/_font_family");
import { subnav_show, subnav_hide, subnav_toggle, m_menu_open } from "@/js/share/components/_header";
import { fastlink_toggle } from "@/js/share/components/_fastlink.js";
import { init_imageloaded } from "@/js/share/components/_imageloader.js";
import { sponsor_swiper } from "@/js/share/components/_sponsor_swiper.js";
import { tracker_handler } from "@/js/share/components/_tracker.js";
import { prevent_rightclick } from "@/js/share/components/_prevent_rightclick.js";


//npm lib  
import $ from "jquery";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import imagesLoaded from "imagesloaded";
import Swiper from "swiper";
import { Pagination, Navigation, Autoplay, EffectFade } from "swiper/modules";
import { createApp } from "vue/dist/vue.esm-browser.prod.js";
import "lazysizes";
import "lazysizes/plugins/parent-fit/ls.parent-fit.js";

const app = createApp({
    data() {
        return {
            menu_open: false,
            fastlink_show: true,
        };
    },
    watch: {
        menu_open: m_menu_open(this),
    },
    mounted() {
        const _this = this;
        this.fastlink_toggle();
        init_imageloaded(function () {
            sponsor_swiper();
        });
    },
    methods: {
        subnav_show,
        subnav_hide,
        subnav_toggle,
        fastlink_toggle,
        tracker_handler,
        prevent_rightclick,
    },
}).mount("#app");
